import { createApiClient } from 'Network/ApiClient';

export const ActivityAllowedICDAxiosInstance = createApiClient('ActivityNotIcd/');


